import * as _ from "lodash";
import http from "../constant/api";

export const TokenService = {
  createSocketToken: async (data) => {
    const result = await http.post(`/api/socket/token/new`, data);

    return result;
  },
  refreshSocketToken: async (data) => {
    const result = await http.post(`/api/socket/token/refresh`, data);

    return result;
  },
};
